<template>
    <div>
        <span v-html="promoLabel" />
        <span v-if="promoEndDate">jusqu’au&#160;{{ promoEndDate }}</span>
    </div>
</template>

<script>
export default {
    props: {
        promoLabel: {
            type: String,
            required: true,
        },
        promoEndDate: {
            type: String,
            required: false,
            default: undefined
        }
    }
}
</script>
